import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BaseClass } from 'src/app/@shared/base-class/base-class';
import { IbaseService } from 'src/app/@shared/base-service/ibase-service';
import { CommonService } from 'src/app/@shared/services/common.service';
import { SharedService } from 'src/app/@shared/services/shared.service';
import { WebserviceService } from 'src/app/@shared/services/webservice.service';
declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent extends BaseClass<any> implements OnInit {
  public menu: any[] = [];
  isCollapsed = false;

  constructor(public _common: CommonService,
    public _shared: SharedService,
    public router: Router,
    public service: WebserviceService) {
      super();
    this._shared.sharedSideMenu.subscribe(data => {
      this.menu
      let sideM = (localStorage.getItem(`${this.env.panel}sideMenu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideMenu`) as any) : [];
      let sideRaceM7 = (localStorage.getItem(`${this.env.panel}sideRaceMenu7`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu7`) as any) : [];
      let sideRaceM4339 = (localStorage.getItem(`${this.env.panel}sideRaceMenu4339`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}sideRaceMenu4339`) as any) : [];
      let menu = (localStorage.getItem(`${this.env.panel}menu`)) ? JSON.parse(localStorage.getItem(`${this.env.panel}menu`) as any) : [];

      let dts = [...sideM, ...sideRaceM7, ...sideRaceM4339];
      dts = dts.sort((a: any, b: any) => {
        let fd = new Date(a.open_date) as any; let ld = new Date(b.open_date) as any;
        return (fd - ld);
      });

      let ids: any[] = [];
      dts.forEach((element: any) => {
        ids.push({ id: element.competition_id, name: element.competition_name });
      });
      ids = [... new Set(ids.map(JSON.stringify as any))].map(JSON.parse as any)

      let tempMenu: any[] = [];
      const mGrouped = this.groupBy(dts, (dat: any) => dat.event_type_id);
      menu.forEach((menuEle: any, i: any) => {
        // console.log(mGrouped.get(menuEle.id));
        let gData = mGrouped.get(menuEle.id) ? mGrouped.get(menuEle.id) : [];
        // if (mGrouped.get(menuEle.id))
          tempMenu.push({ id: menuEle.id, name: menuEle.name, data: gData, child: [] })
      });

      tempMenu.forEach((tEle) => {
        const grouped = this.groupBy(tEle.data, (dat: any) => dat.competition_id);
        ids.forEach((element) => {
          if (grouped.get(element.id))
            tEle.child.push({ name: element.name, data: grouped.get(element.id) })
        });
      });

      this.menu = tempMenu;
    })
  }

  ngOnInit(): void {
  }

  getServices(): IbaseService<any> {
    return this.service;
  }

  preventClick(e:any) {
    e.stopPropagation();
  }
  
  closeSidebar(){
    var body = $('body');
    body.removeClass('sidebar-enable');
  }

  redirectCasinoWithTabSelection(event_type_id:any, pTabId: any): void {
    this.router.navigate(['/casino', event_type_id], { queryParams: { pId: pTabId, cId: 0 } });
  }

}
